import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Nav from './index'
import { useWeb3Context } from '../../contexts/Web3Context'
import Image from 'next/image'
import { shortAddress } from '../../utils/web3'

const useStyles = makeStyles((theme) => ({
  walletContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '30px',
  },
  address: {
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
  },
  disconnect: {
    fontSize: '10px',
  },
  addressContainer: {
    display: 'flex',
    gap: '1rem',
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.8rem',
    padding: '.4rem 1.4rem',
    alignItems: 'center',
  },
  addressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  img: {
    borderRadius: '50%',
    border: '1px solid white !important',
  },
}))

export default function NavBarWithWallet({ variant }: { variant?: 'light' | 'dark' }): JSX.Element {
  const classes = useStyles({})
  const { web3Provider, connect, disconnect, address } = useWeb3Context()

  return (
    <div className={classes.walletContainer}>
      <Nav variant={variant} />
      <div>
        {web3Provider ? (
          <div className={classes.addressContainer}>
            <Image
              src={`https://effigy.im/a/${address}.svg`}
              height="32px"
              width="32px"
              className={classes.img}
            />
            <div className={classes.addressWrapper}>
              <Typography variant="subtitle2" className={classes.address}>
                {shortAddress(address || '')}
              </Typography>
              <Button
                variant="text"
                onClick={() => {
                  if (disconnect) {
                    disconnect()
                  }
                }}
              >
                <Typography variant="caption" className={classes.disconnect}>
                  Disconnect
                </Typography>
              </Button>
            </div>
          </div>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (connect) connect()
            }}
          >
            Connect
          </Button>
        )}
      </div>
    </div>
  )
}
